export { default } from './video-warning';
